import { render, staticRenderFns } from "./RoomDisplay.vue?vue&type=template&id=754082bf&scoped=true&"
import script from "./RoomDisplay.vue?vue&type=script&lang=js&"
export * from "./RoomDisplay.vue?vue&type=script&lang=js&"
import style0 from "./RoomDisplay.vue?vue&type=style&index=0&id=754082bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754082bf",
  null
  
)

export default component.exports